import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Row from "antd/es/row";
import CashDetailsColumn from "./CashDetailsColumn";
import { Col } from "antd";

const SelectedDisclosures = ({
  transactionRecord,
  symbol,
  getFixedTwoDecimalValue,
}) => {
  const { selected_disclosures = [] } = transactionRecord.operationData[0];

  const getTotalAmount = () => {
    let totalAmount = 0;
    selected_disclosures.forEach((obj) => {
      totalAmount += Number(obj.price);
    });
    return totalAmount;
  };
  return (
    <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
      <Row type="flex" justify="space-between" align={"middle"}>
        <Col style={{ paddingTop: "5px" }}>
          <Badge count={"Disclosures"} className="details-badge" />
        </Col>
      </Row>

      {selected_disclosures.map((obj, index) => (
        <CashDetailsColumn
          key={String(index)}
          label={obj.title}
          value={obj.price ? `${symbol}${obj.price}` : "-"}
        />
      ))}

      <CashDetailsColumn
        label={"Total Disclosure Amount"}
        value={`${symbol}${getFixedTwoDecimalValue(getTotalAmount())}`}
      />
    </Card>
  );
};

SelectedDisclosures.propTypes = {
  transactionRecord: PropTypes.object.isRequired,
  symbol: PropTypes.string.isRequired,
};

export default SelectedDisclosures;
